import RouteNames from "@/entities/RouteNames";
import RouteSectionsPrefixes from "@/entities/RouteSectionsPrefixes";
import { RouteRecord } from "vue-router";

interface GetSectionRouteName {
  (args: GetSectionRouteNameArgs): string;
}
interface GetSectionRouteNameArgs {
  routeName: RouteNames | string;
  prefix?: RouteSectionsPrefixes | RouteRecord;
}

export const getSectionRouteName: GetSectionRouteName = ({
  routeName,
  prefix,
}) => {
  if (!prefix) {
    return routeName;
  }

  return `${prefix}_${routeName}`;
};
